import { render } from "./detail.vue?vue&type=template&id=11144a2c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=11144a2c&lang=less&scoped=true"

import exportComponent from "/Users/wangdadan/IdeaProjects/LTCODE/后端管理web端/rent-admin-web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11144a2c"]])

export default __exports__